/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M1.5 9c0-1.6569 1.3432-3 3-3h6.75V.75a.75.75 0 0 1 1.5 0V6h6.75c1.6569 0 3 1.3431 3 3v4.5c0 1.6569-1.3431 3-3 3h-6.75v6.75a.75.75 0 0 1-1.5 0V16.5H4.5c-1.6568 0-3-1.3431-3-3V9ZM21 9c0-.8284-.6716-1.5-1.5-1.5h-15C3.6716 7.5 3 8.1716 3 9v4.5c0 .8284.6716 1.5 1.5 1.5h15c.8284 0 1.5-.6716 1.5-1.5V9Zm-7.5 2.25a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 .75-.75Zm-7.5 0a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75Zm9.75-.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z"
    clipRule="evenodd"
  />,
  'DiagramCollapsed'
);
